import { useIsAdmin } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import { useNavigate } from "@/lib/router-compat";

interface AdminEditButtonProps {
  stockNumber: string;
  className?: string;
  variant?: "icon" | "full";
}

export default function AdminEditButton({ stockNumber, className = "", variant = "icon" }: AdminEditButtonProps) {
  const { isAdmin, loading } = useIsAdmin();
  const navigate = useNavigate();

  if (loading || !isAdmin) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`/admin/inventory?edit=${encodeURIComponent(stockNumber)}`);
  };

  if (variant === "full") {
    return (
      <Button
        variant="outline"
        size="sm"
        onClick={handleClick}
        className={className}
      >
        <Pencil className="h-3.5 w-3.5 mr-1.5" />
        Edit Unit
      </Button>
    );
  }

  return (
    <button
      onClick={handleClick}
      className={`z-10 rounded-full bg-background/80 backdrop-blur p-1.5 shadow-xs hover:bg-background transition ${className}`}
      title="Edit unit (admin)"
    >
      <Pencil className="h-3.5 w-3.5 text-foreground" />
    </button>
  );
}
